import { FC, ReactNode } from 'react';
import { TIER_DISPLAY_NAMES, PortfolioTier } from '../services/tierConfig';

interface ChatPageLayoutProps {
  tier: PortfolioTier;
  onClearHistory: () => void;
  children: ReactNode;
}

const ChatPageLayout: FC<ChatPageLayoutProps> = ({ tier, onClearHistory, children }) => {
  return (
    <div className="flex flex-col h-full bg-white dark:bg-slate-900">
      {/* Header */}
      <div className="flex-shrink-0 border-b border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-4 py-3">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-vine dark:bg-teal-600 flex items-center justify-center">
              <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
            </div>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-white">Portfolio Assistant</h1>
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-vine/10 dark:bg-teal-500/10 text-vine dark:text-teal-400">
              {TIER_DISPLAY_NAMES[tier]}
            </span>
          </div>
          <button
            onClick={onClearHistory}
            className="text-sm text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            Clear History
          </button>
        </div>
      </div>

      {/* Content area */}
      {children}
    </div>
  );
};

export default ChatPageLayout;
